import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/shared/api/ApiError'

/**
 * `/api/me` (roles and permissions). Declared here rather than in the hook so
 * that `api/client.ts` can invalidate it on 401/403 without an import cycle.
 */
export const ME_KEY = ['me'] as const

const isWaking = (e: unknown) => e instanceof ApiError && e.code === 'DATABASE_WAKING'

const retryDelay = (_n: number, e: unknown) =>
  e instanceof ApiError && e.retryAfterSeconds ? e.retryAfterSeconds * 1000 : 2000

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: (failureCount, e) => {
        if (isWaking(e)) return failureCount < 6
        if (e instanceof ApiError && e.status >= 400 && e.status < 500) return false
        // Paused until the 1st of next month: retrying can't help.
        if (e instanceof ApiError && e.code === 'DATABASE_PAUSED') return false
        return failureCount < 1
      },
      retryDelay,
      refetchOnWindowFocus: false,
    },
    mutations: {
      // Only a waking database is safe to resend: the write never happened.
      retry: (failureCount, e) => isWaking(e) && failureCount < 6,
      retryDelay,
    },
  },
})
